import * as yup from 'yup';

// Schémas de validation Yup
const leaderChangeValidationSchema = yup.object().shape({
    change: yup.string().required('Veuillez indiquer le type de modification'),
    function: yup.string().required('Veuillez selectionner une fonction')
});

export default leaderChangeValidationSchema